import { Fragment } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import { useNavigate } from 'react-router';
import * as Sentry from '@sentry/react';

import { AccessDenied, navigationService } from '@wf/sw-ui-kit';
import { PrivateRoute } from '@wf/keycloak-axios-provider';
import { Mode } from '@wf/components';

import DocumentHistory from '../../modules/DocumentHistory/pages/DocumentHistory';
import LicenseChildren from '../../modules/LicenseChildren/pages/LicenseChildren';
import VersionComparison from '../../modules/AuditTrail/pages/VersionComparison';
import Licenses from '../../modules/Licenses/pages/Licenses';
import License from '../../modules/License/pages/License';

import { declarantAndTraderRoles, lpcoAbbreviation, updateRoles, viewRoles } from '../../constants';
import useSecurity from '../../hooks/useSecurity';
import routes from '../../constants/routes';

import { isSentryEnabled } from '../../configs/sentry';

const WFRoutes = isSentryEnabled ? Sentry.withSentryReactRouterV6Routing(Routes) : Routes;

function Router() {
  const navigate = useNavigate();

  const isValidUser = useSecurity();

  navigationService.setNavigate(navigate);

  return (
    <div className="flex flex-column overflow-hidden h-100">
      <WFRoutes>
        {isValidUser && (
          <>
            <Route element={<Navigate to={lpcoAbbreviation.toLowerCase()} />} index />
            {routes.map(({ nature }) => (
              <Fragment key={nature}>
                <Route
                  element={<PrivateRoute roles={viewRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={nature}
                >
                  <Route element={<Licenses key={nature} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={viewRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/view/:id`}
                >
                  <Route element={<License mode={Mode.view} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={updateRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/edit/:id`}
                >
                  <Route element={<License mode={Mode.update} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={declarantAndTraderRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/create`}
                >
                  <Route element={<License mode={Mode.create} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={declarantAndTraderRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/create/:id`}
                >
                  <Route element={<License mode={Mode.create} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={declarantAndTraderRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/generate`}
                >
                  <Route element={<License mode={Mode.create} />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={viewRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/documentHistory/:id`}
                >
                  <Route element={<DocumentHistory />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={viewRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/versionComparison/:id`}
                >
                  <Route element={<VersionComparison />} index />
                </Route>
                <Route
                  element={<PrivateRoute roles={viewRoles} accessDeniedComponent={<AccessDenied />} />}
                  path={`${nature}/:id/children`}
                >
                  <Route element={<LicenseChildren />} index />
                </Route>
              </Fragment>
            ))}
          </>
        )}

        <Route path="accessDenied" element={<AccessDenied />} />
      </WFRoutes>
    </div>
  );
}

export default Router;
